var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPoints = function SvgPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 22c5.52 0 10-4.48 10-10 0-5.53-4.48-10-10-10C6.47 2 2 6.47 2 12c0 5.52 4.47 10 10 10Zm.01-4 .01-.01H12Zm.01-12L12 5.99v-.01Zm3.36 7.6 1.77-1.8c.3-.31.41-.77.28-1.19-.14-.43-.48-.73-.9-.79l-2.46-.38-1.1-2.32c-.19-.4-.58-.65-1-.65h-.01c-.43 0-.81.24-1 .64l-1.1 2.31-2.45.37c-.43.06-.77.36-.91.78-.14.42-.03.88.28 1.19l1.77 1.79-.42 2.54c-.08.43.09.87.44 1.13.19.14.42.22.65.22.17 0 .35-.05.51-.14l2.19-1.2 2.18 1.19c.37.21.82.17 1.17-.09.34-.26.51-.7.44-1.14l-.42-2.55Z"
  })));
};
export default SvgPoints;